import { render, staticRenderFns } from "./ServiceCallManagement.vue?vue&type=template&id=500fc416&scoped=true"
import script from "./ServiceCallManagement.vue?vue&type=script&lang=js"
export * from "./ServiceCallManagement.vue?vue&type=script&lang=js"
import style0 from "./ServiceCallManagement.vue?vue&type=style&index=0&id=500fc416&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500fc416",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAutocomplete,VCard,VCardTitle,VCol,VIcon,VList,VListItemContent,VListItemSubtitle,VListItemTitle,VOverlay,VProgressCircular,VRow,VSelect,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("G:\\Azure-Agent\\_work\\25\\s\\packages\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500fc416')) {
      api.createRecord('500fc416', component.options)
    } else {
      api.reload('500fc416', component.options)
    }
    module.hot.accept("./ServiceCallManagement.vue?vue&type=template&id=500fc416&scoped=true", function () {
      api.rerender('500fc416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Administration/ServiceCallManagement.vue"
export default component.exports